$(document).on("click",".top_review_star_badge",function() {
    var header_height = $("div#mobile-header").height();
        $('html, body').animate({
        scrollTop: $("div#stamped-main-widget").offset().top - header_height - 150
    }, 1200);
});
$(document).on("click",".stamped-container .stamped-review-image a",function() {
    $("html").addClass("stampedpopup_open");
});

$(document).on("click","span.stamped-modal-close",function() {
    $("html").removeClass("stampedpopup_open");
});


Shopify.theme.productPurchaseControls = (() => {
  let appPurchasePending = false;

  function getState(form) {
    const widget = form?.querySelector('lb-vd-qty-selector, lb-vd-cards');
    if (widget) {
      const button = widget.querySelector('.lb-qty-selector-atc-button');
      const tier = widget.querySelector('.lb-qty-selector-tier-wrapper[aria-checked="true"]');
      return {
        widget,
        button,
        busy: appPurchasePending || button?.getAttribute('aria-busy') === 'true',
        needsSelection: !button || button.disabled,
        title: tier?.querySelector('.lb-qty-selector-quantity-text')?.textContent ||
          widget.querySelector('.lb-qty-selector-promo-text')?.textContent || '',
        priceHTML: tier?.querySelector('.lb-qty-selector-discounted-price-text')?.innerHTML || '',
      };
    }

    const button = form?.querySelector('[data-add-to-cart-trigger]');
    return { button, busy: Boolean(button?.disabled) };
  }

  function guideToSelection(target) {
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const control = target.querySelector('[role="radio"], select, input:not([type="hidden"]), button');
    control?.focus({ preventScroll: true });
  }

  function activate(form) {
    const state = getState(form);
    if (state.busy) return;
    if (!state.button || state.needsSelection || !state.button.getClientRects().length) {
      guideToSelection(state.widget || form);
      return;
    }
    state.button.click();
  }

  function setAppPurchasePending(pending) {
    appPurchasePending = pending;
    document.dispatchEvent(new Event('sb:purchase-state-change'));
  }

  document.addEventListener('lbDealeasyAddProductsToCart', () => setAppPurchasePending(true), true);
  window.addEventListener('lbDealeasyProductsAddedToCart', () => setAppPurchasePending(false));
  window.addEventListener('lbDealeasyProductsNotAddedInCart', () => setAppPurchasePending(false));

  document.addEventListener('click', event => {
    const button = event.target.closest('.custom-add-btn00[data-product-purchase]');
    if (!button) return;
    event.preventDefault();
    const productForm = document.getElementById(`product-form-${button.dataset.productPurchase}`);
    const form = productForm?.querySelector('form[action*="/cart/add"]');
    if (form) activate(form);
    else if (button.dataset.productUrl) window.location.assign(button.dataset.productUrl);
  });

  return { getState, activate };
})();


